import _Object$keys from '@babel/runtime-corejs3/core-js-stable/object/keys';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import _forEachInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors';
import _Object$defineProperties from '@babel/runtime-corejs3/core-js-stable/object/define-properties';
import _Object$defineProperty from '@babel/runtime-corejs3/core-js-stable/object/define-property';
import _extends from '@babel/runtime-corejs3/helpers/extends';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import { c as clsx } from '../clsx.m-7e9a4a81.js';
import React__default, { useRef, useCallback } from 'react';
import { CSSTransition } from 'react-transition-group';
import '@babel/runtime-corejs3/helpers/typeof';
import '@babel/runtime-corejs3/core-js-stable/array/is-array';

var _excluded = ["active", "unmountOnExit", "className", "style", "children", "classNames"];

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; _forEachInstanceProperty(_context = ownKeys(Object(source), true)).call(_context, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

var CollapsePanel = function CollapsePanel(props) {
  var active = props.active,
      unmountOnExit = props.unmountOnExit,
      className = props.className,
      style = props.style,
      children = props.children,
      classNames = props.classNames,
      rest = _objectWithoutProperties(props, _excluded);

  var ref = useRef(null);
  var handleExit = useCallback(function () {
    if (ref.current) {
      ref.current.style.height = "".concat(ref.current.scrollHeight, "px");
      void ref.current.scrollHeight; // 此处触发一次repaint
    }
  }, []);
  return /*#__PURE__*/React__default.createElement(CSSTransition, {
    classNames: classNames,
    "in": active,
    onExit: handleExit,
    timeout: 300,
    unmountOnExit: unmountOnExit
  }, function (transition) {
    var _ref$current;

    return /*#__PURE__*/React__default.createElement("div", _extends({
      className: clsx('smb-collapse-panel', className),
      ref: ref,
      style: _objectSpread(_objectSpread({}, style), {
        entering: {
          height: (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.scrollHeight,
          transition: 'all .3s cubic-bezier(0.66, 0, 0, 1)'
        },
        entered: {
          height: undefined
        },
        exiting: {
          height: 0,
          marginTop: 0,
          marginBottom: 0,
          transition: 'all .3s'
        },
        exited: {
          height: 0,
          marginTop: 0,
          marginBottom: 0
        },
        unmounted: {
          height: undefined,
          marginTop: 0,
          marginBottom: 0
        }
      }[transition])
    }, rest), children);
  });
};

var Collapse = {
  Panel: CollapsePanel
};

export default Collapse;
